import React from 'react'
import Merchant from '@/src/interfaces/merchant/merchant'
import { useTranslations } from 'next-intl'

interface Props {
    openingHours: Merchant.OpeningHour[];
}

const getNextOpeningHour = (openingHours: Merchant.OpeningHour[]): { day: string; time: string } | null => {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

    const now = new Date()
    const currentDay = daysOfWeek[now.getDay()]
    const currentTime = now.toTimeString().slice(0, 8)

    const t = useTranslations('profile')

    const sortedHours = openingHours.sort((a, b) => {
        return daysOfWeek.indexOf(a.dayOfWeek) - daysOfWeek.indexOf(b.dayOfWeek) || a.startTime.localeCompare(b.startTime)
    })

    for (let i = 0; i < sortedHours.length; i++) {
        const { dayOfWeek, startTime } = sortedHours[i]

        if ((dayOfWeek === currentDay && startTime > currentTime) || daysOfWeek.indexOf(dayOfWeek) > daysOfWeek.indexOf(currentDay))
            return { day: t(dayOfWeek.toLowerCase()).toLowerCase(), time: startTime.slice(0, 5) }
    }

    const firstOpening = sortedHours[0]

    return firstOpening ? { day: firstOpening.dayOfWeek, time: firstOpening.startTime.slice(0, 5) } : null
}

export default function NextOpeningHour({ openingHours }: Props) {
    const renderClosedLabel = () => {
        const nextOpening = getNextOpeningHour(openingHours)

        if (!nextOpening) return <>Fechado no momento</>

        const nextOpeningHour = nextOpening.time

        return <span style={{ textAlign: 'center' }}>Fechado no momento • Abrimos {nextOpening.day} às {nextOpeningHour}</span>
    }

    return renderClosedLabel();
}